import { OverlayTrigger, Popover } from "react-bootstrap";

export default function CustomFieldInfoIcon({ CustomFieldNames, bodyLabel = null, iconTitle = "", customWidth = "300px" }) {


    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">Coverage Colors</Popover.Header>
            <Popover.Body style={{ margin: '0 10px' }}>

                <div className="row pt-1">
                    {CustomFieldNames?.length > 0 ?
                        CustomFieldNames?.map((customField, index) => (
                            <>
                                <div className="col-9 pb-2">
                                    <label className=" text-wrap">{customField.name}</label>
                                </div>
                                <div className="col-3 pb-2">
                                    <div style={{ color: customField.color }}>
                                        <label style={{
                                            width: '14px',
                                            height: '14px',
                                            backgroundColor: customField.color,
                                            borderRadius: '50%'
                                        }}>
                                        </label>
                                    </div>
                                </div>
                            </>
                        ))
                        :
                        <>
                            <div className='col-12 text-center'>No Coverage Fields</div>
                        </>
                    }
                </div>

            </Popover.Body>
        </Popover>
    );

    return (
        <>
            {bodyLabel ?
                <span className="serial-tooltip-wrapper" title=""
                    onClick={(e) => e.stopPropagation()} style={{ '--custom-tooltip-width': customWidth }}>
                    <img
                        src="/images/InfoIcon.svg"
                        className="info-icon ps-1"
                        height="14"
                        alt="info"
                        title={iconTitle}
                    />
                    <span className="serial-tooltip-text" title="">
                        <div className="row pt-1">
                            <div className='col-12'>
                                {bodyLabel}
                            </div>
                        </div>
                    </span>
                </span>
                : <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="right"
                    overlay={popover}
                >
                    <img src="/images/InfoIcon.svg" title='' className="info-icon ps-2" height="14" />
                </OverlayTrigger>
            }
        </>
    )
}